import React, { useState, useCallback } from 'react';
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  Modal,
  TextField,
} from '@material-ui/core';
import { ArrowRight, Phone, X } from 'phosphor-react';
import OtpInput from 'react-otp-input';

import {
  sendVerification,
  togglePhoneVerifyModal,
} from '../../../../../actions/dashboard';
import { PhoneVerificationIcon } from '../../../../utility/Icons';
import { updateProfile, verifyUser } from '../../../../../actions/auth';
import { normalizePhone, parsePhoneNumber } from '../../../../../lib/helpers';
import styles from '../../../../../styles/sass/components/Verification.module.scss';

interface PhoneModalProps {
  phoneNumber: string | number | undefined;
  dispatch: Function;
  showPhoneVerifyModal: boolean;
  modalStyle: any;
  token: string;
}

export default function PhoneVerificationModal({
  phoneNumber,
  dispatch,
  showPhoneVerifyModal,
  modalStyle,
  token,
}: PhoneModalProps) {
  const [showNumberField, setNumberField] = useState(
    !phoneNumber ? true : false,
  );
  const [otp, setOtp] = useState('');
  const [tempNumber, setNumber] = useState(
    phoneNumber ? normalizePhone(`${phoneNumber}`) : '',
  );

  const handlePhoneNumber = (event: any) => {
    const text = event.target.value;
    const formattedNumber = normalizePhone(text);
    setNumber(formattedNumber);
  };
  const handlePhoneVerify = () => {
    dispatch(verifyUser({ phoneNumberVerificationToken: otp }, token));
  };
  const handleResend = useCallback(() => {
    dispatch(sendVerification('phone', token, true));
  }, []);

  const updatePhoneNumber = () => {
    dispatch(updateProfile({ phoneNumber: tempNumber }, token, false, true));
    setTimeout(() => {
      handleResend();
      setNumberField(false);
    }, 300);
  };

  const valid = otp && otp.length === 6;
  const phoneValid = parsePhoneNumber(tempNumber).length === 10;

  return (
    <Modal
      open={showPhoneVerifyModal}
      onClose={() => dispatch(togglePhoneVerifyModal(false))}
      style={modalStyle}
    >
      <div className={styles.verificationModal}>
        <div className={styles.header}>
          <PhoneVerificationIcon />
          <IconButton
            onClick={() => dispatch(togglePhoneVerifyModal(false))}
            className={styles.xIcon}
          >
            <X size={32} color="#323232" weight="regular" />
          </IconButton>
        </div>
        {showNumberField ? (
          <React.Fragment>
            <h3 className={styles.title}>Add/Edit your phone number</h3>
            <FormControl style={{ width: '90%' }}>
              <TextField
                className={styles.numberField}
                fullWidth
                placeholder="(123)-456-7890"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone size={32} weight="fill" color="#195A50" />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                }}
                inputProps={{
                  style: {
                    color: '#2D2332',
                    fontSize: 24,
                    marginLeft: 10,
                  },
                }}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'row',
                }}
                onChange={handlePhoneNumber}
                value={tempNumber}
              />
            </FormControl>
            <Button
              onClick={updatePhoneNumber}
              disabled={!phoneValid}
              className={`${styles.verifyButton} ${
                phoneValid ? styles.validButton : styles.invalidButton
              }`}
            >
              Send verification{' '}
              <ArrowRight
                color={phoneValid ? '#ffffff' : '#E2E2E2'}
                size={32}
                style={{ marginLeft: 10 }}
              />
            </Button>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <h3 className={styles.title}>Let’s verify your number</h3>
            <p className={styles.subText}>
              Code sent to <b>{normalizePhone(`${phoneNumber}`)}</b>
            </p>
            <p className={styles.subText}>
              Not the right number?{' '}
              <span
                onClick={() => setNumberField(true)}
                className={styles.link}
              >
                Edit phone number
              </span>
            </p>

            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              shouldAutoFocus
              placeholder={'000000'}
              isInputNum
              containerStyle={styles.otpContainer}
              inputStyle={styles.otpInput}
              focusStyle={styles.optInputFocused}
            />
            <h3 className={styles.title}>Didn’t receive your code?</h3>
            <h3 onClick={handleResend} className={styles.resend}>
              Resend
            </h3>

            <Button
              onClick={handlePhoneVerify}
              disabled={!valid}
              className={`${styles.verifyButton} ${
                valid ? styles.validButton : styles.invalidButton
              }`}
            >
              Verify{' '}
              <ArrowRight
                color={valid ? '#ffffff' : '#E2E2E2'}
                size={32}
                style={{ marginLeft: 10 }}
              />
            </Button>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
}
